import { render, staticRenderFns } from "./AddSchedule.vue?vue&type=template&id=3042db6b&"
import script from "./AddSchedule.vue?vue&type=script&lang=js&"
export * from "./AddSchedule.vue?vue&type=script&lang=js&"
import style0 from "./AddSchedule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
